<template>
  <div class="iframeStyle">
    <!--iframe 外联组件 地址输入框  -->
    <el-form :inline="true"
             :model="formInline"
             class="demo-form-inline">
      <el-form-item label="外链地址">
        <el-input v-model="formInline"
                  @change="addressChange"
                  placeholder="地址"></el-input>
      </el-form-item>
      <el-form-item>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
export default {
  name: 'iframeHyperlinks',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data () {
    return {
      formInline: '',
      fontStyle: {},
    };
  },
  created () {
    this.fontStyle = this.propertyData[this.propertyDataKey].fontStyle || null;
  },
  mounted () {
    this.formInline = this.propertyData[this.propertyDataKey].value;
  },
  methods: {
    addressChange (val) {
      console.log(val, '111121');
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.iframeStyle {
  width: 100%;
  margin: 0 15px;
  :deep().el-input__inner {
    background-color: #191b23;
    background-image: none;
    border-radius: 4px;
    border: 1px solid rgba(139, 139, 139, 0.733);
    box-sizing: border-box;
    color: #b6b8cc;
    display: inline-block;
    font-size: inherit;
    height: 35px;
    line-height: 35px;
    outline: none;
    padding: 0 6px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 108%;
    &:hover {
      border: 1px solid #3179ff;
    }
    &:focus {
      border: 1px solid #3179ff;
    }
  }
  :deep().el-form-item {
    margin-bottom: 2px;
    margin-top: 8px;
  }
  :deep().el-form-item__label {
    flex: 0 0 auto;
    text-align: right;
    font-size: 14px;
    color: #a0a1b4;
    line-height: 40px;
    padding: 0 8px 0 0;
    box-sizing: border-box;
  }
}
</style>